import { Skeleton } from "@/components/ui/skeleton";
import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { BookOpen } from "lucide-react";
import { Form } from "../-components/reservation-form";
import { useGetFullReservation } from "../-hooks/use-get-full-reservation";

export const Route = createFileRoute("/(reservations)/reservations/$id/edit")({
  component: RouteComponent,
});

function RouteComponent() {
  const { id } = Route.useParams();
  const { isLoading, data } = useGetFullReservation(id);
  const navigate = useNavigate();
  return (
    <Form
      clients={data.clients ?? []}
      accommodations={data.accommodations ?? []}
      reservationdays={data.days ?? []}
      services={data.services ?? []}
      reservation={data.reservation}
      isLoading={isLoading}
      onSuccess={(id) => {
        navigate({ to: "/reservations/$id", params: { id } });
      }}
      crumbs={[
        {
          content: (
            <>
              {isLoading || !data.reservation ? (
                <Skeleton className="h-3 w-28" />
              ) : (
                (data.reservation.agencyReservationNumber ??
                data.reservation.id)
              )}
              <BookOpen width={16} height={16} />
            </>
          ),
          href: "/reservations/$id",
          params: { id },
        },
      ]}
    />
  );
}
